export default __webpack_public_path__ + "static/media/de.55cb1f23.svg";